import { MutationTree } from 'vuex';
import { CalendarState, CalendarFilter } from './types';
import ICalendarData from '@/modules/calendar/interfaces/ICalendarData';

export const mutations: MutationTree<CalendarState> = {
    storeWeekdaysContainerWidth(state, weekdaysContainerWidth: number) {
        if (weekdaysContainerWidth > 0) state.weekdaysContainerWidth = weekdaysContainerWidth;
    },
    storeWeekdayContainerWidth(state, weekdayContainerWidth: number) {
        if (weekdayContainerWidth > 0) state.weekdayContainerWidth = weekdayContainerWidth;
    },
    storeLocationWidth(state, locationWidth: number) {
        if (locationWidth > 0) state.locationWidth = locationWidth;
    },
    storeBoxWidth(state, boxWidth: number) {
        if (boxWidth > 0) state.boxWidth = boxWidth;
    },
    storeCellHeight(state, cellHeight: number) {
        if (cellHeight > 0) state.cellHeight = cellHeight;
    },
    storeBoxType(state, boxType: string) {
        if (boxType !== undefined) state.boxType = boxType;
    },
    storeIsMobile(state, isMobile: boolean) {
        state.isMobile = isMobile;
    },
    storeEvents(state, events: ICalendarData[]) {
        state.events = events;
    },
    storeFilteredEvents(state, filteredEvents: ICalendarData[]) {
        state.filteredEvents = filteredEvents;
    },
    storeAllHours(state, allHours: number[]) {
        state.allHours = allHours;
    },
    storeHoursWithEvents(state, hoursWithEvents: number[]) {
        state.hoursWithEvents = hoursWithEvents;
    },
    storeOpenedSingleActivityPopups(state, openedSingleActivityPopups: number[]) {
        state.openedSingleActivityPopups = openedSingleActivityPopups;
    },
    storeOpenedSingleActivityPopup(state, openedSingleActivityPopupId: number) {
        state.openedSingleActivityPopups.push(openedSingleActivityPopupId);
    },
    storeCalendarFilter(state, calendarFilter: CalendarFilter) {
        state.calendarFilters[calendarFilter.propertyName] = calendarFilter;
    },
    storeCalendarFilters(state, calendarFilters: { [key: string]: CalendarFilter }) {
        state.calendarFilters = calendarFilters;
    },
    storeHiddenFilters(state, hiddenFilters: string) {
        state.hiddenFilters = hiddenFilters.trim();
    },
};
